import { render } from "./MailList.vue?vue&type=template&id=7e1d165e&scoped=true"
import script from "./MailList.vue?vue&type=script&lang=js"
export * from "./MailList.vue?vue&type=script&lang=js"

import "./MailList.vue?vue&type=style&index=0&id=7e1d165e&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1d165e"]])

export default __exports__